// OrganizationDetailsEdit.js

import React from "react";
import { useRef } from "react";
import { Text, View } from "react-native";
import Button from "components/Partials/Buttons";
import TextInputRef from "components/Partials/TextInputRef";
import formRefs from "components/helpers/formrefs";
import { triggerAlert } from "components/Partials/AlertModal";

const Subscriber = ({customerObjState, getOrgDetails, onToggleEditOrgDetails}) => {
	const _theme = window.main.theme;

	const orgFormRefs = useRef(new formRefs());

	const onSubmitCreate = async ()=>{
		try {
			window.main.lib.setLoadingState(true);
			const fieldsData = orgFormRefs.current.getAll();
			fieldsData.organization_id = customerObjState.organization_id;
			const result = await window.main.axios.post(window.main.api.organizationCreate, fieldsData);
			window.main.lib.setLoadingState(false);
			// ⬆ CREATE returns: { success: true, organization_id: created_organization_id, login_username:created_username, login_password:created_password }
			if (!customerObjState.organization_id) {
				// Load the 'VIEW' state for the new Organization.
				window.main.lib.setCurrentView(`/organization/view/${result.data.organization_id||customerObjState.organization_id}`, {});
				getOrgDetails(true);
			} else {
				// Refresh the 'VIEW' state for the existing Organization.
				getOrgDetails(true);
			}
		} catch (err) {
			window.main.lib.setLoadingState(false);
			console.log("err =", err);
			triggerAlert({
				show: true,
				title: "Submission Error",
				message: window.main.lib.parseErrorMessage(err),
			});
		}
	};

	const onSubmitUpdate = async ()=>{
		try {
			const fieldsData = orgFormRefs.current.getAll();
			fieldsData.organization_id = customerObjState.organization_id;
			window.main.lib.setLoadingState(true);
			await window.main.axios.post(window.main.api.organizationUpdate, fieldsData);  // ⬅ UPDATE Returns: { success: true }
			window.main.lib.setLoadingState(false);
			// Refresh the 'VIEW' state for the existing Organization.
			getOrgDetails(true);
		} catch (err) {
			window.main.lib.setLoadingState(false);
			console.log("err =", err);
			triggerAlert({
				show: true,
				title: "Submission Error",
				message: window.main.lib.parseErrorMessage(err),
			});
		}
	};

	const disabledOrganization = async ()=>{
		triggerAlert({
			show: true,
			title: "Confirm Disabled",
			message: `You have selected to Disabled\nthis organization:\n\n'${customerObjState.name}'\n\nAre you sure?`,
			closeOnTouchOutside: true,
			closeOnHardwareBackPress: true,
			showCancelButton: true,
			cancelText: "Cancel",
			onCancelPressed: () => {
				triggerAlert();
			},
			showConfirmButton: true,
			confirmButtonColor: window.main.theme.colors.warn,
			confirmText: "Disable",
			onConfirmPressed: async () => {
				triggerAlert();
				confirmDisabledOrganization();
			},
		});
	};

	const confirmDisabledOrganization = async ()=>{
		try {
			window.main.lib.setLoadingState(true);
			const result = await window.main.axios.post(window.main.api.organizationDisable, {organization_id:customerObjState.organization_id});
			window.main.lib.setLoadingState(false);
			if (!customerObjState.organization_id) {
				// Load the 'VIEW' state for the new Organization.
				window.main.lib.setCurrentView(`/organization/view/${result.organization_id||customerObjState.organization_id}`, {});
			} else {
				// Refresh the 'VIEW' state for the existing Organization.
				getOrgDetails(true);
			}
		} catch (err) {
			window.main.lib.setLoadingState(false);
			console.log("err =", err);
			triggerAlert({
				show: true,
				title: "Submission Error",
				message: window.main.lib.parseErrorMessage(err),
			});
		}
	};

	const enabledOrganization = async ()=>{
		triggerAlert({
			show: true,
			title: "Confirm Enabled",
			message: `You have selected to Enabled\nthis organization:\n\n'${customerObjState.name}'\n\nAre you sure?`,
			closeOnTouchOutside: true,
			closeOnHardwareBackPress: true,
			showCancelButton: true,
			cancelText: "Cancel",
			onCancelPressed: () => {
				triggerAlert();
			},
			showConfirmButton: true,
			confirmButtonColor: window.main.theme.colors.success,
			confirmText: "Enable",
			onConfirmPressed: async () => {
				triggerAlert();
				confirmEnabledOrganization();
			},
		});
	};

	const confirmEnabledOrganization = async ()=>{
		try {
			window.main.lib.setLoadingState(true);
			const result = await window.main.axios.post(window.main.api.organizationEnable, {organization_id:customerObjState.organization_id});
			window.main.lib.setLoadingState(false);
			if (!customerObjState.organization_id) {
				// Load the 'VIEW' state for the new Organization.
				window.main.lib.setCurrentView(`/organization/view/${result.organization_id||customerObjState.organization_id}`, {});
			} else {
				// Refresh the 'VIEW' state for the existing Organization.
				getOrgDetails(true);
			}
		} catch (err) {
			window.main.lib.setLoadingState(false);
			console.log("err =", err);
			triggerAlert({
				show: true,
				title: "Submission Error",
				message: window.main.lib.parseErrorMessage(err),
			});
		}
	};

	const deleteOrganization = async ()=>{
		triggerAlert({
			show: true,
			title: "Confirm Delete",
			message: `You have selected to Delete\nthis organization:\n\n'${customerObjState.name}'\n\nAre you sure?`,
			closeOnTouchOutside: true,
			closeOnHardwareBackPress: true,
			showCancelButton: true,
			cancelText: "Cancel",
			onCancelPressed: () => {
				triggerAlert();
			},
			showConfirmButton: true,
			confirmButtonColor: window.main.theme.colors.caution,
			confirmText: "Delete",
			onConfirmPressed: async () => {
				triggerAlert();
				confirmDeleteOrganization();
			},
		});
	};

	const confirmDeleteOrganization = async ()=>{
		try {
			window.main.lib.setLoadingState(true);
			await window.main.axios.post(window.main.api.organizationDelete, {organization_id:customerObjState.organization_id});
			window.main.lib.setLoadingState(false);
			if (!customerObjState.organization_id) {
				// Load the 'VIEW' state for the new Organization.
				window.main.lib.setCurrentView("/subscribers");
			} else {
				// Refresh the 'VIEW' state for the existing Organization.
				getOrgDetails(true);
			}
		} catch (err) {
			window.main.lib.setLoadingState(false);
			console.log("err =", err);
			triggerAlert({
				show: true,
				title: "Submission Error",
				message: window.main.lib.parseErrorMessage(err),
			});
		}
	};

	// Organization refs
	const orgNameRef = useRef();
	const orgShortNameRef = useRef();
	const orgPhoneRef = useRef();
	const orgEmailRef = useRef();
	const orgWebsiteRef = useRef();
	const orgFacebookRef = useRef();
	const orgInstagramRef = useRef();
	// Location refs
	const locationNameRef = useRef();
	const locationShortnameRef = useRef();
	// Staff refs
	const staffFirstNameRef = useRef();
	const staffLastNameRef = useRef();
	const staffEmailRef = useRef();

	return (
		<View style={{..._theme.container,flexShrink:1,borderWidth:0,paddingVertical:14,paddingHorizontal:(_theme.responsiveKey==="phone"?10:0),maxWidth:(window.main.platform_os!=="web"?400:_theme.respWidth)}}>
			{(!!customerObjState && typeof(customerObjState)==="object" && !!customerObjState.hasOwnProperty("organization_id")) &&
				<View style={{..._theme.containerLiner,flexShrink:1,marginBottom:30}}>
					<View style={{..._theme.containerTitle}}>
						<View style={{flexDirection:"row",flexGrow:1}}>
							<Text style={_theme.containerTitleText}>{!!customerObjState.organization_id?"New Subscriber":"Edit Subscriber Details"}</Text>
						</View>
					</View>
					<View style={{display:"flex",flexDirection:"column",justifyContent:"flex-start",alignItems:"stretch",flexGrow:1,flexShrink:1,alignSelf:"stretch",position:"relative"}}>

						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Organization Name:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<TextInputRef ref={orgNameRef} formrefs={orgFormRefs.current} datakey={"name"} textValue={customerObjState.name} style={{..._theme.textInput,width:300}} />
								<Text style={{..._theme.fieldLabelSubtext}}>(For all official communications.)</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Short Name:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<TextInputRef ref={orgShortNameRef} formrefs={orgFormRefs.current} datakey={"shortname"} textValue={customerObjState.shortname} style={{..._theme.textInput,width:200}} />
								<Text style={{..._theme.fieldLabelSubtext}}>(For internal references in this website.)</Text>
							</View>
						</View>

						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",marginTop:50,marginBottom:20}}>
							<Text style={{color:_theme.colors.mode.textColor,fontWeight:600}}>The following are used in outgoing communications:</Text>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Public Phone Number:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<TextInputRef ref={orgPhoneRef} formrefs={orgFormRefs.current} datakey={"public_phone"} textValue={customerObjState.public_phone} style={{..._theme.textInput,width:130}} />
								<Text style={{..._theme.fieldLabelSubtext}}>(For client email communications.)</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Public Email Address:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<TextInputRef ref={orgEmailRef} formrefs={orgFormRefs.current} datakey={"public_email"} textValue={customerObjState.public_email} style={{..._theme.textInput,width:300}} />
								<Text style={{..._theme.fieldLabelSubtext}}>(For client email communications.)</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Public Website URL:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<TextInputRef ref={orgWebsiteRef} formrefs={orgFormRefs.current} datakey={"public_website"} textValue={customerObjState.public_website} style={{..._theme.textInput,width:300}} />
								<Text style={{..._theme.fieldLabelSubtext}}>(For client email communications.)</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Facebook URL:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<TextInputRef ref={orgFacebookRef} formrefs={orgFormRefs.current} datakey={"public_facebook"} textValue={customerObjState.public_facebook} style={{..._theme.textInput,width:300}} />
								<Text style={{..._theme.fieldLabelSubtext}}>(For client email communications.)</Text>
							</View>
						</View>
						<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
							<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
								<Text style={{color:_theme.colors.mode.textColor}}>
									Instragram URL:
								</Text>
							</View>
							<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
								<TextInputRef ref={orgInstagramRef} formrefs={orgFormRefs.current} datakey={"public_instagram"} textValue={customerObjState.public_instagram} style={{..._theme.textInput,width:300}} />
								<Text style={{..._theme.fieldLabelSubtext}}>(For client email communications.)</Text>
							</View>
						</View>

						{customerObjState.organization_id===0 &&
							<>
								<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",marginTop:50,marginBottom:20}}>
									<Text style={{color:_theme.colors.mode.textColor,fontWeight:600}}>First Clinic Location Name:</Text>
								</View>
								<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
									<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
										<Text style={{color:_theme.colors.mode.textColor}}>
											Location Name:
										</Text>
									</View>
									<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
										<TextInputRef ref={locationNameRef} formrefs={orgFormRefs.current} datakey={"location_name"} textValue="" style={{..._theme.textInput,width:300}} />
										<Text style={{..._theme.fieldLabelSubtext}}>(Additional locations may be added later.)</Text>
									</View>
								</View>
								<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
									<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
										<Text style={{color:_theme.colors.mode.textColor}}>
											Short Name:
										</Text>
									</View>
									<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
										<TextInputRef ref={locationShortnameRef} formrefs={orgFormRefs.current} datakey={"location_shortname"} textValue="" style={{..._theme.textInput,width:300}} />
										<Text style={{..._theme.fieldLabelSubtext}}>(Internal only, if the Location Name is long.)</Text>
									</View>
								</View>

								<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",marginTop:50,marginBottom:20}}>
									<Text style={{color:_theme.colors.mode.textColor,fontWeight:600}}>Admin User Account:</Text>
								</View>
								<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
									<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
										<Text style={{color:_theme.colors.mode.textColor}}>
											First Name:
										</Text>
									</View>
									<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
										<TextInputRef ref={staffFirstNameRef} formrefs={orgFormRefs.current} datakey={"first_name"} textValue="" style={{..._theme.textInput,width:300}} />
									</View>
								</View>
								<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
									<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
										<Text style={{color:_theme.colors.mode.textColor}}>
											Last Name:
										</Text>
									</View>
									<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
										<TextInputRef ref={staffLastNameRef} formrefs={orgFormRefs.current} datakey={"last_name"} textValue="" style={{..._theme.textInput,width:300}} />
									</View>
								</View>
								<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center"}}>
									<View style={{flexDirection:"row",justifyContent:"flex-start",alignItems:"center",padding:5,flexGrow:0,flexBasis:160}}>
										<Text style={{color:_theme.colors.mode.textColor}}>
											Login Email Address:
										</Text>
									</View>
									<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",padding:5,flexGrow:1}}>
										<TextInputRef ref={staffEmailRef} formrefs={orgFormRefs.current} datakey={"email"} textValue="" style={{..._theme.textInput,width:300}} />
									</View>
								</View>
							</>
						}
					</View>
					<View style={{flexDirection:"row",justifyContent:"stretch",alignItems:"center",paddingTop:50}}>
						<Button nativeID="saveEditOrgDetails" type="primary" ficon="check" text={!!customerObjState.organization_id?"Update Subscriber Details":"Create New Subscriber"} onpress={!!customerObjState.organization_id?onSubmitUpdate:onSubmitCreate} style={{width:260}} />
						<Button nativeID="cancelEditOrgDetails" type="secondary" ficon="x" text="Cancel" onpress={onToggleEditOrgDetails} style={{width:260,marginLeft:20}} />
						{customerObjState.organization_id>0 && !customerObjState.is_disabled &&
							<Button nativeID="disabledOrganization" type="ancillary" ficon="alert-triangle" text="Disabled Organization" onpress={disabledOrganization} style={{width:260,marginLeft:20}} />
						}
						{customerObjState.organization_id>0 && !!customerObjState.is_disabled &&
							<Button nativeID="enabledOrganization" type="successary2" ficon="alert-triangle" text="Enabled Organization" onpress={enabledOrganization} style={{width:260,marginLeft:20}} />
						}
						{customerObjState.organization_id>0 && !!customerObjState.is_disabled &&
							<Button nativeID="deleteOrganization" type="cautionary2" ficon="alert-triangle" text="Delete Organization" onpress={deleteOrganization} style={{width:260,marginLeft:20}} />
						}
					</View>
				</View>
			}
		</View>
	);
};

export default Subscriber;
